/* eslint-disable */
export default {
  cancel: 'Annuler',
  reply: 'Répondre',
  onMyWay: 'En route',
  customMessage: 'Personnaliser le message',
  callMeBackIn: 'Rappelez-moi dans',
  willCallYouBackIn: 'Vous rappellera dans',
  min: ' min',
  hours: ' heures',
  days: ' jours',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
